import { useCallback } from 'react'

import LeadService from 'modules/lead/service'
import { useTransmissionContext } from 'modules/transmission/context/transmissionContext'

const useVerifyAcceptedLead = () => {
  const { transmissionData: { code } } = useTransmissionContext()

  const verifyAcceptedLead = useCallback(async (name: string, email: string) => {
    if (!code || !email) {
      return void 0
    }

    const { accepted } = await LeadService.getAccepted({
      schedule: code,
      name,
      email
    }) || {}

    return { accepted }
  }, [code])

  return verifyAcceptedLead
}

export default useVerifyAcceptedLead
